import * as React from "react";
import { StyledStep } from "../../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Child Results</h1>
        <p className="step-text">
          Click the initials of your child here and I will show you their
          Performance Learning results.
        </p>
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
  {
    selector: ".step-2",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Navigation</h1>
        <p className="step-text">
          <span>S stands for Summary</span> , here I will show you an overview
          of your Performance Learning results.{" "}
          <span>CF stands for Comparison Filters</span>, take a look and you can
          compare the Performance Learning results of your children.
          <span>SF stands for Search Filters</span>, here I will dig deep into
          your Performance Learning results for you and your children.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-5",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Choose an Assessment</h1>
        <p className="step-text">
          We recommend a Performance Learning Assessment is completed every
          three months, from the dropdown tell me which assessment results you
          want to review and I will display them on screen for you.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-3",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Performance Learning Score &amp; Profile</h1>
        <p className="step-text">
          Here you'll see the Performance Learning score for the assessment you
          have selected as well as the results description.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-6",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Perceptions</h1>
        <p className="step-text">
          Click here and I will show you the Perception areas identified in the
          selected assessment. Perceptions range from needing No Attention to
          Urgent Attention Needed.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-4",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Responses</h1>
        <p className="step-text">
          Take a look here and I will show you all of the responses given in the
          selecteD Performance Learning Assessment.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Parent/ParentDataCenterTour.tsx